import clsx from "clsx";

import RichPortableText from "./rich-text";
import { SanitySideNavSection } from "./rich-text/types";

type SideNavProps = {
  sections: SanitySideNavSection[];
  side: "right" | "left";
};
const SideNav = ({ sections, side }: SideNavProps) => (
  <aside
    className={clsx(
      "hidden px-4 pb-4 border-gray-200 bg-gray-100 basis-1/3 lg:basis-1/4 shrink-0 md:block",
      side === "left" ? "lg:pr-6 border-r-4" : "lg:pl-6 border-l-4"
    )}
  >
    <div className="sticky top-20 space-y-8 overflow-auto">
      {sections.map(section => (
        <article key={section._key} className="space-y-2">
          <p className="text-gray-500">{section.title}</p>
          <RichPortableText value={section.content} />
        </article>
      ))}
    </div>
  </aside>
);

export default SideNav;
